var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row flex-wrap  my-4 w-full md:w-2/3 lg:w-3/4"},_vm._l((_vm.products),function(product,key){return _c('product-card-component',{key:key,attrs:{"product":product}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }